<template>
    <div id="header" class="rel" :style="{ position: headTop }">
        <nav class="pc-body" v-if="!isApp && showCommon">
            <div class="logo l">
                <img src="~IMAGE/header/logo.png" usemap="#header-logo" />
                <map name="header-logo">
                    <area shape="rect" coords="0,0,96,24" alt="reolink" :href="getOfficialUrl( `${config.reolink}/` )" target="_blank">
                    <area shape="rect" coords="122,0,196,24" alt="reolink" href="/">
                </map>
            </div>
            <div class="dashboard" v-show="isLogin">
                <reo-nav></reo-nav>
            </div>
            <div class="avatarAndLang r">
                <div class="nav-item avatar l" v-show="isLogin">
                    <a class="">
                        <div class="avatar-wrap nav-avatar" :style="{'background-image': `url('${avatarUrl}')`}"></div>
                        <span class="ui-icon icon-icon_down-2"></span>
                    </a>
                    <div class="nav-dropdown">
                        <i class="border-gradient ui-gradient-blue"></i>
                        <ul>
                            <li><a :href="profileUrl" target="_blank">{{ $t("dashboard.accountSettings") }}</a></li>
                            <li><a @click="logOut">{{ $t("login.logOut") }}</a></li>
                        </ul>
                    </div>
                </div>
                <div class="nav-item avatar l" v-show="!isLogin">
                    <a :href="loginDashboardUrl" target="_blank">
                        <div class="avatar-wrap nav-avatar" :style="{'background-image': `url('${defaultAvatar}')`}"></div>
                    </a>
                </div>
                <div class="nav-item lang r" v-if="!FEATURE('main.multi_language')">
                    <a><span>{{currenLang}}</span><span class="ui-icon icon-icon_down-2"></span></a>
                    <div class="nav-dropdown lang-nav-dropdown">
                        <i class="border-gradient ui-gradient-blue"></i>
                        <ul>
                            <li v-for="(lang, index) in langList" :key="index">
                                <a href="javascript:void(0)" @click="selectLang(lang)">{{ $t(`lang.pc.${lang}`) }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
        <nav class="mobile-body" v-if="!isApp && showCommon">
            <div class="head-menu">
                <a href="javascript:void(0);" class="menu" id="show-menu" @click="loginShow = !loginShow">
                    <i class="menu-icon icon-icon_caidan"></i>
                </a>
            </div>
            <img v-if="!cartNav.show" src="~IMAGE/header/logo-m.png" class="logo log-brand" usemap="#header-logo-m" alt="reolink">
            <div v-else class="m-cart-nav">
                <span>{{ $t(`${cartNav.action}`) }}</span>
                <div class="dots">
                    <div v-for="(value, index) in 3" :key="index" :class="[{
                        active: cartNav.step > index
                    }]"></div>
                </div>
                <div class="line"></div>
                <div class="line active" :style="{
                    width: cartNav.step === 1 ? '40%' : ( cartNav.step === 2 ? '60%' : '100%' )
                }"></div>
            </div>
            <map name="header-logo-m">
                <area shape="rect" :coords="`0,0,${x1},${height}`" alt="reolink" :href="getOfficialUrl( `${config.reolink}/` )" target="_blank">
                <area shape="rect" :coords="`${x2},0,${width},${height}`" alt="reolink" href="/">
            </map>
        </nav>
    
        <top-info></top-info>
        <login-detail
        :login-id="userId"
        :login-avatarurl="avatarUrl"
        :login-show="loginShow"
        @closeLogin="closeLogin"
        @logIn="logIn"
        @signUp="signUp"
        @logOut="logOut"
        ></login-detail>
    </div>
</template>

<script>

import LoginDetail from '@/components/loginDetail';
import TopInfo from '@/components/topInfo';
import { mapGetters, mapMutations } from 'vuex';
import { config } from 'CONFIG';
import ReoNav from '@/basic/Nav';
import { headerHandle } from '@/common/js/header';

export default {

    props: {

        showCommon: Boolean,
        isApp: Boolean

    },

    components: {

        ReoNav,
        LoginDetail,
        TopInfo

    },

    data () {

        return {

            langList: config.langList,
            loginShow: false,
            x1: 0,
            x2: 0,
            height: 0,
            width: 0,
            headTop: false,
            config

        };

    },

    destroyed () {

        window.removeEventListener( 'resize', this.resizeHandle );

    },

    computed: {

        isLogin () {

            return this.userId;

        },

        loginTargetUrl () {

            return config.accountCenterLoginUrl + '?redirect=' + window.location.origin + '/user/dashboard/';

        },

        signUpTargetUrl () {

            return config.accountCenterSignupUrl + '?redirect=' + window.location.origin + '/user/dashboard/';

        },

        profileUrl () {

            return config.accountCenterProfileUrl;

        },

        logoutUrl () {

            return config.accountCenterLogoutUrl;

        },

        defaultAvatar () {

            return config.defaultAvatar;

        },

        getCloudHost () {

            return window.location.hostname;

        },

        loginDashboardUrl () {

            return config.accountCenterLoginUrl + '?redirect=' + window.location.origin + '/user/dashboard/';

        },

        ...mapGetters( [

            'avatarUrl',
            'userId',
            'pageSkip',
            'cloudHost'

        ] ),

        currenLang () {

            let lang = this.$store.state.lang.lang;
            return this.$t( `lang.pc.${lang}` );

        },

        cartNav () {

            let path = this.$route.path;
            let cartNav = {
                show: true
            };
            if ( path === '/user/update-plan/' ) {

                cartNav.step = 1;
                cartNav.action = 'cart_nav.choose_plan';

            } else if ( path === '/user/subscribe-plan/' ) {

                cartNav.step = 1;
                cartNav.action = 'cart_nav.choose_plan';

            } else if ( path === '/checkout/' ) {

                cartNav.step = 2;
                cartNav.action = 'cart_nav.confirm_details';

            } else if ( path === '/checkout/payment-complete/' || path === '/user/complete/' ) {

                cartNav.step = 3;
                cartNav.action = 'cart_nav.complete';

            } else {

                cartNav.show = false;

            }
            return cartNav;

        }

    },

    methods: {

        closeLogin () {

            this.loginShow = false;

        },

        logIn () {

            window.location.href = this.loginTargetUrl;

        },

        signUp () {

            window.location.href = this.signUpTargetUrl;

        },

        logOut () {

            this._logOut();
            window.location.href = this.logoutUrl + '?redirect=' + window.location.origin;

        },

        ...mapMutations({

            _logOut: 'LOGOUT',
            _setCloudHost: 'SETCLOUDHOST'

        }),

        selectLang ( lang ) {

            this.$store.commit( 'SELECT_LANG', lang );
            this.$i18n.locale = lang;
            headerHandle( this.$route );

        },

        calStyle () {

            let logo = $( '#header .mobile-body .logo.log-brand' );

            if ( logo.length > 0 ) {
                
                let width = logo[ 0 ].offsetWidth;
                this.x1 = width * 0.439;
                this.x2 = width * 0.561;
                this.width = width;
                this.height = width * 0.114;

            }

        },

        scroll () {

            let scroll = document.body.scrollTop || document.documentElement.scrollTop;
            let dis = config.platform === 'app' ? 1 : 64;
            if ( scroll >= dis ) {

                this.headTop = 'fixed';

            } else {

                this.headTop = 'relative';

            }

        }

    },

    created () {

        this._setCloudHost( this.getCloudHost );

    },

    mounted () {

        this.calStyle();
        window.addEventListener( 'resize', () => {
            
            this.closeLogin();
            this.calStyle();

        });
        window.addEventListener( 'scroll', this.scroll );

    },

    watch: {

        pageSkip ( val ) {

            this.loginShow = false;

        }

    }

};
</script>

<style type="text/css" lang="less">

    #header{
        z-index: 5;
        position: relative;
        width: 100%;
        top: 0;
    }

    #header .pc-body{
        height: .88rem;
        padding: 0 .48rem;
        line-height: .38rem;
        box-sizing: border-box;
        position: relative;
        background-color: #fff;
        box-shadow : 0 6px 22px rgba(0, 0, 0, 0.05);
        -webkit-box-shadow: 0 6px 22px rgba(0, 0, 0, 0.05);
        -moz-box-shadow: 0 6px 22px rgba(0, 0, 0, 0.05);
        -o-box-shadow: 0 6px 22px rgba(0, 0, 0, 0.05);
        -ms-box-shadow: 0 6px 22px rgba(0, 0, 0, 0.05);
    }

    #header .pc-body .nav-item:hover{
        cursor: pointer;
    }

    #header .pc-body a{
        font-weight: 500;
    }

    #header .pc-body .avatar{
        margin-right: .48rem;
    }

    #header .pc-body .logo{
        padding: .06rem 0;
        box-sizing: border-box;
        height: .38rem;
        margin-top: .23rem;
    }

    #header .pc-body .ui-icon{
        font-size: .12rem;
        margin-left: .16rem;
        position: relative;
        top: -.02rem;
    }

    #header .pc-body .avatar .ui-icon{
        top: -.15rem;
        color: #333;
    }

    #header .pc-body .avatar .nav-avatar{
        height: .38rem;
        width: 0.38rem;
        border-radius: 50%;
        margin-top: .23rem;
        border: 1px solid #f1f1f1;
        display: inline-block;
    }

    #header .pc-body .avatar a{
        display: block;
    }

    #header .pc-body .avatar>a {
        height: 0.88rem;
    }

    #header .pc-body .dashboard{
        display: inline-block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        line-height: .88rem;
    }

    .nav-item .nav-dropdown{
        display: none;
        background-color: #fff;
        -o-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
        -ms-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
        z-index: 99;
        opacity: 1;
        position: absolute;
        left: 50%;
        transform: translateX(-55%);
    }

    .nav-item .nav-dropdown.lang-nav-dropdown {
        transform: translateX(-70%);
    }

    .dashboard .nav-dropdown{
        width: 2rem;
        margin-left: -.45rem;
    }

    #header .nav-dropdown li{ line-height: .6rem; position: relative; }
    #header .nav-dropdown li a{
        padding: 0 .2rem;
        color: #555;
        font-size: .16rem;
        font-weight: 500;
        text-decoration: none;
        display: block;
        text-align: center;
        line-height: .6rem;
        border-bottom: 0;
        margin: 0;
        white-space: nowrap;
    }
    #header .nav-dropdown li a:hover{
        background-color: #f7f8f9;
        color: @theme;
    }

    #header .pc-body .nav-item:hover .nav-dropdown{
        display: block;
    }

    #header .mobile-body{
        padding: .2rem 15px;
        background-color: #fff;
        box-shadow : 0 0.06rem 0.3rem rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0 0.06rem 0.3rem rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 0 0.06rem 0.3rem rgba(0, 0, 0, 0.1);
        -o-box-shadow: 0 0.06rem 0.3rem rgba(0, 0, 0, 0.1);
        -ms-box-shadow: 0 0.06rem 0.3rem rgba(0, 0, 0, 0.1);
    }

    #header .mobile-body .head-menu .menu-icon{
        font-size: .6rem;
        color: #333;
    }

    #header .mobile-body .head-menu .menu {
        display: block;
    }

    #header .mobile-body div{
        display: inline-block;
    }

    #header .mobile-body .head-brand img{
        height: .32rem;
        width: auto;
        position: relative;
        top: -.08rem;
    }

    .avatarAndLang .nav-item{
        line-height: .88rem;
        position: relative;
    }

    .avatarAndLang .nav-item.lang{
        font-size: 0.16rem;
    }

    #header .mobile-body .head-brand{
        margin-left: 1.54rem;
    }

    #header .mobile-body{
        display: none;
    }

    #header .nav-item.avatar .nav-dropdown{
        width: 1.8rem;
    }

    #header .nav-item.avatar .nav-dropdown li a{
        font-size: 0.16rem;
        padding: 0;
    }

    .cloud-fillter{
        position: static;
        top: 88px;
        width: 100%;
        z-index: 4;
    }

    @media screen and ( max-width: 1199px ) {
        .cloud-fillter{
            top: 1rem;
        }
        #header .pc-body{
            display: none;
        }
        #header .mobile-body{
            display: block;
            height: 1rem;
            box-sizing: border-box;
            position: relative;
        }
        #header .mobile-body .head-menu{
            float: left;
        }
        .log-brand{
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            -webkit-transform: translate(-50%,-50%);
            width: 3.3rem;
        }
        .log-brand img{
            width: 100%;
        }
    }
    .m-cart-nav{
        &>span{
            position: absolute;
            display: block;
            text-align: center;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 0.36rem;
        }
        .line{
            position: absolute;
            width: 100%;
            border-top: 1px solid #B1B1B1;
            left: 0;
            bottom: 0;
            &.active{
                border-color: @theme;
            }
        }
        .dots{
            position: absolute;
            width: 100%;
            left: 0;
            bottom: -0.05rem;
            text-align: center;
            height: 0.1rem;
            font-size: 0;
            div{
                display: inline-block;
                width: 0.1rem;
                height: 0.1rem;
                border-radius: 100%;
                background-color: #B1B1B1;
                &.active{
                    background-color: @theme;
                }
            }
            div+div{
                margin-left: 1.2rem;
            }
        }

    }

</style>



// WEBPACK FOOTER //
// src/view/Header.vue